import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Layout from './components/layout/Layout';
import Home from './components/main/Home/Home';
import AboutUS from './components/main/pages/AboutUs/AboutUS';
import ContactUs from './components/main/pages/ContactUS/ContactUs';
import Gallery from './components/main/pages/ProjectGallery/Gallery';
import PrivicyPolicy from './components/main/pages/PrivicyPolicy/PrivicyPolicy';
import EarthWork from './components/main/pages/EarthWork/EarthWork';
import Concrete from './components/main/pages/Concrete/Concrete';
import Utilities from './components/main/pages/Utilities/Utilities';
import Emergenci from './components/main/pages/Emergenci/Emergenci';
import { Toaster } from 'react-hot-toast';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import ImageGallery from './components/main/pages/ImageGallery/ImageGallery';

// 🔹 ScrollToTop Component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" }); // always go top instantly
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              padding: "12px 20px",
              borderRadius: "8px",
              color: "#fff",
            },
            success: {
              style: {
                background: "green",
              },
            },
            error: {
              style: {
                background: "red",
              },
            },
          }}
        />
        <Routes>
          {/* Guest routes here */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<AboutUS />} />
            <Route path="contact-us" element={<ContactUs />} />
            {/* <Route path="project-gallery" element={<Gallery />} /> */}
            <Route path="gallery" element={<ImageGallery />} />
            <Route path="privicy-policy" element={<PrivicyPolicy />} />
            <Route path="earthworks" element={<EarthWork />} />
            <Route path="concrete" element={<Concrete />} />
            <Route path="utilities" element={<Utilities />} />
            <Route path="emergenci-service" element={<Emergenci />} />
            {/* <Route path="*" element={<NoPageFound />} /> */}
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
